module.exports = __webpack_public_path__ + "5d28fd12c7433b81ec65e095c2227a6a.ttf";